import { Game } from '../game.model';

export class End {
  game: Game;
}
